import * as z from "zod"
import { CompleteDBCustomerOrderItem, RelatedDBCustomerOrderItemModel } from "./index"

export const DBClientCustomerOrderModel = z.object({
  id: z.string(),
  orderNumber: z.number().int(),
})

export interface CompleteDBClientCustomerOrder extends z.infer<typeof DBClientCustomerOrderModel> {
  customerOrders: CompleteDBCustomerOrderItem[]
}

/**
 * RelatedDBClientCustomerOrderModel contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
export const RelatedDBClientCustomerOrderModel: z.ZodSchema<CompleteDBClientCustomerOrder> = z.lazy(() => DBClientCustomerOrderModel.extend({
  customerOrders: RelatedDBCustomerOrderItemModel.array(),
}))
